import styled from 'styled-components';


export const CardsWrapper = styled.div`
    display:grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap:5px;
   

    @media(max-width:1200px){
        grid-template-columns: 1fr 1fr;
    }
    @media(max-width:900px){
        grid-template-columns:1fr;
    }
`;

export const GridContainer = styled.div`
    display:flex;
    flex-direction: column;
    padding:10px;
    border-radius: 4px;
    box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);

    
    ::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }

    ::-webkit-scrollbar-thumb {
        background-color: rgba(0,0,0,0.2);
        border-radius: 4px;
    }

    ::-webkit-scrollbar-track {
        background-color: #eaeaea;
    }


    @media(max-width:320px){
        overflow-x:scroll;
        padding:5px;
    }
}
    
`;